var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.003 16.075C28.003 9.406 22.63 4 16.003 4 9.373 4.002 4 9.406 4 16.076c0 6.026 4.389 11.021 10.125 11.927v-8.438H11.08v-3.489h3.048v-2.662c0-3.025 1.793-4.697 4.533-4.697 1.314 0 2.686.236 2.686.236v2.97h-1.513c-1.49 0-1.954.931-1.954 1.887v2.265h3.326l-.53 3.489h-2.798v8.438c5.736-.906 10.125-5.901 10.125-11.927Z",
    fill: "#1777F0"
  })));
};
export default SvgFacebook;